import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { TrialSupportLink } from "../models/trial-support-link.model";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class TrialSupportLinkService {
  constructor(private readonly http: HttpClient) {
  }

  /**
   * Updates an existing support link on a trial
   * @param trialId
   * @param linkId
   * @param link
   */
  public update(trialId: string, linkId: string, link: TrialSupportLink) {
    return this.http.put<TrialSupportLink[]>(environment.apiUrl + '/TrialSupportLink/' + trialId + '/' + linkId, link);
  }

  /**
   * Adds a new support link to a trial
   * @param trialId
   * @param link
   */
  public add(trialId: string, link: TrialSupportLink) {
    return this.http.post<TrialSupportLink[]>(environment.apiUrl + '/TrialSupportLink/' + trialId, link);
  }

  public remove(trialId: string, linkId: string) {
    return this.http.put<TrialSupportLink[]>(environment.apiUrl + '/TrialSupportLink/Remove/' + trialId + '/' + linkId, {});
  }

  public list(trialId: string) {
    return this.http.get<TrialSupportLink[]>(environment.apiUrl + '/TrialSupportLink/' + trialId);
  }
}
